import React from "react";

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Grid from '../../components/Grid'
import Image from '../../components/Image'


import grid from '../../assets/images/brandbook/grid/grid.001.jpeg'
import grid2 from '../../assets/images/brandbook/grid/grid.002.jpeg'
import grid3 from '../../assets/images/brandbook/grid/grid.003.jpeg'
import grid4 from '../../assets/images/brandbook/grid/grid.004.jpeg'
import grid5 from '../../assets/images/brandbook/grid/grid.005.jpeg'
import grid6 from '../../assets/images/brandbook/grid/grid.006.jpeg'
import grid7 from '../../assets/images/brandbook/grid/grid.007.jpeg'
import grid18 from '../../assets/images/brandbook/grid/grid.018.jpeg'
import grid9 from '../../assets/images/brandbook/grid/grid.009.jpeg'
import grid10 from '../../assets/images/brandbook/grid/grid.010.jpeg'
import grid11 from '../../assets/images/brandbook/grid/grid.011.jpeg'
import grid14 from '../../assets/images/brandbook/grid/grid.014.jpeg'
import grid15 from '../../assets/images/brandbook/grid/grid.015.jpeg'
import grid22 from '../../assets/images/brandbook/grid/grid.022.jpeg'
import grid17 from '../../assets/images/brandbook/grid/grid.017.jpeg'
import grid21 from '../../assets/images/brandbook/grid/grid.021.jpeg'

export const path = '/brandbook/grid'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Grid/Layout</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">
      <Section>
          <Grid grid="1-2">
            <></>
            <>
              <p>
                We use a simple 3, 6 or 12 column grid based on context and application and combine it with white space to build hierarchy and focus.
              </p>
            </>
          </Grid>
      </Section>
      <Grid grid="3">
        <p>1</p>
        <p>2</p>
        <p>3</p>
      </Grid>
      <Grid grid="6">
        <p>1</p>
        <p>2</p>
        <p>3</p>
        <p>4</p>
        <p>5</p>
        <p>6</p>
      </Grid>
      <Grid grid="12">
      <p>1</p>
      <p>2</p>
      <p>3</p>
      <p>4</p>
      <p>5</p>
      <p>6</p>
      <p>7</p>
      <p>8</p>
      <p>9</p>
      <p>10</p>
      <p>11</p>
      <p>12</p>
      </Grid>
      <Section>
        <Grid grid="3">

          <Image imageUrl={grid} aspect="16/9" />
          <Image imageUrl={grid14} aspect="16/9" />
          <Image imageUrl={grid2} aspect="16/9" />
          <Image imageUrl={grid21} aspect="16/9" />
          <Image imageUrl={grid22} aspect="16/9" />
          <Image imageUrl={grid3} aspect="16/9" />
          <Image imageUrl={grid4} aspect="16/9" />
          <Image imageUrl={grid18} aspect="16/9" />
          <Image imageUrl={grid9} aspect="16/9" />

        </Grid>
      </Section>



    <br />
    </Container>
    </div>
    )
  }
